<template>
    <Modal class="modal modal--mob modal-radio-buttons">
        <template #header>
            <h2>{{$t('form_fields.smoking_label')}}</h2>
        </template>
        <template #body>
            <div v-for="s in smokingOptions" :key="s.code" class="radiobox">
                <input class="form-check-input" type="radio" :id="s.code" :checked="value === s.value">
                <label @click="update(s.value)" class="radiobox__label" :for="s.code">
                    {{$t(`form_fields.smoking_options_${s.value}`)}}
                </label>
            </div>
        </template>
        <template #footer>
            <a @click="$emit('success')" class="skip">{{$t('credits.skip_for_now')}}</a>
        </template>
    </Modal>
</template>

<script>

import Modal from "@/components/generic/Modal";
import { smoking } from "@/service/forms"
import AuthenticatedMixin from "@/mixins/AuthenticatedMixin";

export default {
    name: "OnDemandSmoking",
    mixins: [AuthenticatedMixin],
    components: { Modal },
    props: {
        value: {
            type: [Number, null],
            required: true
        }
    },

    methods: {

        update(value) {

            this.$emit('set', {
                smoking: value
            })

        }

    },

    created() {
        this.smokingOptions = smoking
    },
    mounted() {
        this.smoking = this.auth.user.smoking
    },
    beforeUnmount() {
        clearTimeout(this.timeout)
    }
}
</script>